import { AxiosResponse } from 'axios';
import axios from '../api/axios';
import {
  LedRGB,
  LedWhite,
  LedSchedule,
  PoleListQueryResponse,
  PoleQueryResponse,
} from './_models';

const GET_POLE_LIST_URL = '/app/pole/list';

export const getPoles = (): Promise<PoleListQueryResponse> => {
  return axios
    .get(GET_POLE_LIST_URL)
    .then((d: AxiosResponse<PoleListQueryResponse>) => d.data)
    .catch(() => [] as never);
};

export const setPoleLedRBG = (
  id: number,
  config: LedRGB
): Promise<PoleQueryResponse> => {
  return axios
    .post(`/app/pole/${id}/rgb`, config)
    .then((d: AxiosResponse<PoleQueryResponse>) => d.data)
    .catch(() => [] as never);
};

export const setPoleLedWhite = (
  id: number,
  config: LedWhite
): Promise<PoleQueryResponse> => {
  return axios
    .post(`/app/pole/${id}/white`, config)
    .then((d: AxiosResponse<PoleQueryResponse>) => d.data)
    .catch(() => [] as never);
};

export const setPoleLedSchedule = (
  id: number,
  config: LedSchedule
): Promise<PoleQueryResponse> => {
  return axios
    .post(`/app/pole/${id}/schedule`, config)
    .then((d: AxiosResponse<PoleQueryResponse>) => d.data)
    .catch(() => [] as never);
};

export const setPoleAlarms = (
  id: number,
  active: boolean
): Promise<PoleQueryResponse> => {
  return axios
    .post(`/app/pole/${id}/alarms`, { active })
    .then((d: AxiosResponse<PoleQueryResponse>) => d.data)
    .catch(() => [] as never);
};
